const SixABAAInfrastructureContent = `

Form of report for claiming deduction under clause (xi) of sub-section (1) of section 36.

1. Omitted by the Income Tax (Twenty-first Amdt.) Rules, 2021, Notification No. 83/2021 dated 29-7-2021.




`;

export default SixABAAInfrastructureContent;